module.exports = __webpack_public_path__ + "media/images/sp/items/gift/kiribako_detail_01-4291757caf81e775b5f1a5b6b88d0808.jpg";